import { render, staticRenderFns } from "./cerfafioul.vue?vue&type=template&id=39488d9d&scoped=true&"
import script from "./cerfafioul.vue?vue&type=script&lang=js&"
export * from "./cerfafioul.vue?vue&type=script&lang=js&"
import style0 from "./cerfafioul.vue?vue&type=style&index=0&id=39488d9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39488d9d",
  null
  
)

export default component.exports